import { render, staticRenderFns } from "./MessageOptions.vue?vue&type=template&id=409588e3&"
import script from "./MessageOptions.vue?vue&type=script&lang=ts&"
export * from "./MessageOptions.vue?vue&type=script&lang=ts&"
import style0 from "./MessageOptions.vue?vue&type=style&index=0&id=409588e3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports